
import Normal from './Normal/Normal';
import Dark from './Dark/Dark';
import Parchment from './Parchment/Parchment';
import Minimal from './Minimal/Minimal';
import Elegant from './Elegant/Elegant';

const templates = {
  Normal,
  Dark,
  Parchment,
  Minimal,
  Elegant,
};

export default templates;
